import classnames from "classnames";
import styles from "./ClickContainer.module.scss";

const ClickContainer = ({ className, children }) => (
  <div className={classnames(styles.container, className)}>{children}</div>
);

export default ClickContainer;
